import React from "react";
import ReactDOM from "react-dom/client";
import { Outlet, RouterProvider, createBrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import appStore from "./utils/appStore";
import { ThemeProvider } from "./utils/ThemeContext";

import Header from "./src/Header";
import Footer from "./src/Footer";
import Body from "./src/Body";
import RestaurantMenu from "./src/RestaurantMenu";
import CartPage from "./src/CartPage";
import Error from "./src/Error";

const AppLayout: React.FC = () => {
    return (
        <Provider store={appStore}>
            <ThemeProvider>
                <div className="min-h-screen flex flex-col bg-gray-50 dark:bg-gray-900 text-gray-900 dark:text-gray-100 transition-colors duration-200">
                    <Header />
                    <Outlet />
                    <Footer />
                </div>
            </ThemeProvider>
        </Provider>
    );
};

const appRouter = createBrowserRouter([
    {
        path: "/",
        element: <AppLayout />,
        errorElement: <Error />,
        children: [
            {
                path: "/",
                element: <Body />,
            },
            {
                path: "/restaurant/:resId",
                element: <RestaurantMenu />,
            },
            {
                path: "/cart",
                element: <CartPage />,
            },
        ],
    },
]);

const rootElement = document.getElementById("root");
if (rootElement) {
    const root = ReactDOM.createRoot(rootElement);
    root.render(<RouterProvider router={appRouter} />);
}

